import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b293da3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { key: 0 }

interface Props {
  /** two-way bound checked state */
  modelValue?: boolean;
  /** text to show in label */
  text: string;
  /** icon to show in label */
  icon?: string;
}

interface Emits {
  /** two-way bound checked state */
  (event: "update:modelValue", checked: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCheckbox',
  props: {
    modelValue: { type: Boolean },
    text: null,
    icon: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  /** two-way bound checked state */
  (event: "update:modelValue", checked: boolean): void;
}), expose: any, slots: any, attrs: any }) {





/** when checkbox value changes */
function onChange(event: Event) {
  emit("update:modelValue", (event?.target as HTMLInputElement).checked);
}

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      class: "input",
      checked: __props.modelValue,
      onChange: onChange
    }, null, 40, _hoisted_2),
    _createVNode(_component_AppIcon, {
      class: "check",
      icon: __props.modelValue ? 'square-check' : 'square'
    }, null, 8, ["icon"]),
    (__props.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true),
    (__props.icon)
      ? (_openBlock(), _createBlock(_component_AppIcon, {
          key: 1,
          class: "icon",
          icon: __props.icon
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true)
  ]))
}
}

})